// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let UserSchool
export default UserSchool = class UserSchool extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {}
